export const autoSuggestPanelProps = () => ({
  shops: {
    type: Array,
    default: null
  },
  keyWord: {
    type: String,
    default: null
  },
  categories: {
    type: Array,
    default: null
  },
  products: {
    type: Array,
    default: null
  },
  isNational: {
    type: Boolean,
    required: true
  },
  headerLight: {
    type: Boolean,
    required: false,
    default: false
  },
  autosuggestIsLoading: {
    type: Boolean,
    required: false,
    default: false
  },
  historyLoading: {
    type: Boolean,
    required: false,
    default: false
  },
  suggestionWords: {
    type: Array,
    required: false,
    default: () => []
  },
  wordSuggestions: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  },
  historyWords: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  }
})

export const autoSuggestPanelEmits = () => ([
  "fetchSerchResults",
  "closePanel",
  "selectWordSuggestion",
  "removeSearchHistory",
  "removeWordInHistory"
])

export const useAutoSuggestPanel = (context, props) => {
  const fetchSerchResults = () => {
    context.emit("fetchSerchResults");
  };
  const closePanel = (from = null) => {
    context.emit('closePanel', from)
  };
  const preventClosePanel = (event) => {
    event.stopPropagation();
  };
  return {
    fetchSerchResults,
    closePanel,
    preventClosePanel
  }
}